var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g({class:['p-inputtext p-component', {'p-filled': _vm.filled}],domProps:{"value":_vm.value}},_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }